import { Pressable, StyleSheet, View, type ViewStyle } from "react-native";
import Svg, { Path } from "react-native-svg";

import type { LockBadgeProps } from "./types";

export interface LockBadgeNativeProps extends LockBadgeProps {
  style?: ViewStyle;
}

export function LockBadge({
  accessibilityLabel = "Locked",
  backgroundColor = "#F6B452",
  iconColor = "#4A3810",
  onPress,
  size = 20,
  style,
}: LockBadgeNativeProps) {
  const content = (
    <>
      <Svg height={size * 0.5} viewBox="0 0 16 16" width={size * 0.5}>
        <Path
          d="M7.99682 11.5659C8.59697 11.5659 9.08349 11.0794 9.08349 10.4792C9.08349 9.8791 8.59697 9.39258 7.99682 9.39258C7.39667 9.39258 6.91016 9.8791 6.91016 10.4792C6.91016 11.0794 7.39667 11.5659 7.99682 11.5659Z"
          fill={iconColor}
        />
        <Path
          d="M12.1932 6.35008V5.51674C12.1932 3.71674 11.7598 1.33008 8.00651 1.33008C4.25318 1.33008 3.81984 3.71674 3.81984 5.51674V6.35008C1.95318 6.58341 1.33984 7.53008 1.33984 9.85674V11.0967C1.33984 13.8301 2.17318 14.6634 4.90651 14.6634H11.1065C13.8398 14.6634 14.6732 13.8301 14.6732 11.0967V9.85674C14.6732 7.53008 14.0598 6.58341 12.1932 6.35008ZM8.00651 12.4901C6.89318 12.4901 5.99318 11.5834 5.99318 10.4767C5.99318 9.36341 6.89984 8.46341 8.00651 8.46341C9.11318 8.46341 10.0198 9.37008 10.0198 10.4767C10.0198 11.5901 9.11984 12.4901 8.00651 12.4901ZM4.90651 6.29008C4.85318 6.29008 4.80651 6.29008 4.75318 6.29008V5.51674C4.75318 3.56341 5.30651 2.26341 8.00651 2.26341C10.7065 2.26341 11.2598 3.56341 11.2598 5.51674V6.29674C11.2065 6.29674 11.1598 6.29674 11.1065 6.29674H4.90651V6.29008Z"
          fill={iconColor}
        />
      </Svg>
    </>
  );
  const badgeStyle = [
    styles.badge,
    { width: size, height: size, borderRadius: size / 2, backgroundColor },
    style,
  ];

  return onPress ? (
    <Pressable
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      hitSlop={8}
      onPress={onPress}
      style={badgeStyle}
    >
      {content}
    </Pressable>
  ) : (
    <View
      accessibilityElementsHidden
      importantForAccessibility="no-hide-descendants"
      pointerEvents="none"
      style={badgeStyle}
    >
      {content}
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#211D18",
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.28,
    shadowRadius: 3.5,
    elevation: 4,
  },
});
